import React from 'react';
import { useSiteSettings } from '../../context/SiteSettingsContext';

const Footer = () => {
  const { settings } = useSiteSettings();
  const footerText = settings?.text?.adminFooterText || '� 2026 SifrifanaShop Admin Panel. All rights reserved.';

  return (
    <footer
      style={{
        backgroundColor: 'var(--color-header-bg)',
        color: 'var(--color-header-text)',
        padding: '20px',
        textAlign: 'center',
      }}
    >
      <p>{footerText}</p>
    </footer>
  );
};

export default Footer;




